






































































































































import { Component } from 'vue-property-decorator';
import { Getter } from "vuex-class";
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import EmailEventsGroupFilter from "@/components/Email/EmailEventsGroupFilter.vue";
import { GroupItem, GroupFilterParams } from '@/store/sms/statistic/types';
import GroupCharts from "@/components/Reports/GroupCharts.vue";

@Component({ components: {EmailEventsGroupFilter, ScrollButton, GroupCharts}})
export default class EmailEventsGroup extends BaseItemsPage<GroupItem> {

  @Getter("emailStatisticGroup") responseItems: any;

  is_show_filter = true;
  is_show_graphics = true;

  currentSort = "date";

  tableFields = this.tableFieldsDefault;

  groupBy = '';
  optionallyGroupBy = '';

  onGroupByChange(data: any) {
    this.groupBy = data.groupBy
    this.optionallyGroupBy = data.optionallyGroupBy
  }

  getFieldName(name: string) {
    if (name == 'partner_price') return 'charged'
    return name
  }

  print(item: string, totalRow: boolean) {
    if (totalRow) return item
    return item ?? this.$t('unnamed')
  }

  getData() {
    return this.responseItems?.events;
  }

  get tableFieldsDefault() {
    return [
      'openings', 'following_links', 'unsubscribings', 'subscribings', 'total'
    ];
  }

  get totalData() {
    let total = {...this.responseItems?.events_summary, totalRow: true}
    if (this.groupBy) {
      total.date = this.$t('total')
    } else if (this.optionallyGroupBy) {
      total[this.optionallyGroupBy] = this.$t('total')
    }
    return total
  }

  get compareData() {
    return [...this.queriedData, this.totalData];
  }

}
